export default __webpack_public_path__ + "static/media/facebook.443fe2be.png";